<mat-card appearance="outlined" class="container">
  <mat-card-header class="secondary-background-element main-card flex-center">


<span class="spacer"></span>

<button mat-icon-button (click)="addClinicOffice()" class="flex-child-wrapper">
  <mat-icon>add</mat-icon>
</button>
<button mat-icon-button (click)="refreshTable()" class="flex-child-wrapper">
  <mat-icon svgIcon="refresh"></mat-icon>
</button>
</mat-card-header>

<mat-card-content>


  <!--  table columns definitions -->
  <table mat-table matSort color="accent" class='closer-sort' aria-label="Elements" [dataSource]="dataSource"
    [matSortActive]="this.dataSource.sortingHeader" [matSortDirection]="this.dataSource.sortDirection">

    <ng-container matColumnDef="clinicOfficeId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>ID</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{row.clinicOfficeId}}</span>
      </td>
    </ng-container>



    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>Name</h3>
      </th>
      <td mat-cell *matCellDef="let row" [matTooltip]="row.name">
        <h3 class="not-bold">{{row.name}}</h3>
      </td>
    </ng-container>


    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>City</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.city) {
          <div>
            {{row.city}}
          </div>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <h3>Brand</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.brand) {
          <div>
            <span>{{getBrandName(row.brand)}}</span>
          </div>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="entAmount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered-header">
        <h3>ENTs</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.entAmount) {
          <div>
            <span>{{row.entAmount}}</span>
          </div>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="hcpAmount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered-header">
        <h3>HCPs</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.hcpAmount) {
          <div>
            <span>{{row.hcpAmount}}</span>
          </div>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="patientsAmount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered-header">
        <h3>Patients</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.patientsAmount) {
          <div>
            <span>{{row.patientsAmount}}</span>
          </div>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered-header">
        <h3>Status</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.shown==true) {
          <div>
            <mat-icon fontIcon="visibility"></mat-icon>
          </div>
        }
        @if (row.shown==false) {
          <div>
            <mat-icon fontIcon="visibility_off"></mat-icon>
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <h3>Actions</h3>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="flex actions">
          @if (row.waitsForPublishing) {
            <button mat-raised-button class="small" color="accent"
              (click)="publishClinicOffice(row)">
              Review
            </button>
          }
          <button mat-icon-button (click)="showInfoDialog(row)">
            <mat-icon class='secondary-contrast-icon' svgIcon="tooltip"></mat-icon>
          </button>

          <button matTooltip="Edit info" mat-icon-button (click)="editClinicOffice(row)">

            <mat-icon class='secondary-contrast-icon'>edit</mat-icon>
          </button>
        </div>


      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>

  <!-- progress indicator that we are to indicate that data is being loaded from the backend  -->
  @if ((this.dataSource.loading$ | async); as loading) {
    <div class="spinner-container">
      <mat-spinner color="accent" [diameter]="30" class="spinner-diametser-30"></mat-spinner>
    </div>
  }

  <mat-paginator color='accent' [length]="dataSource.count" [pageIndex]=" this.dataSource.pageIndex"
    [pageSize]="this.dataSource.pageSize" [pageSizeOptions]="[10,20,50]">
  </mat-paginator>
</mat-card-content>
</mat-card>

<ng-template #sentButton>
  <button mat-icon-button disabled class="immitation-button">
    <mat-icon svgIcon='checkmark' class="sent-button-icon secondary-contrast-icon"></mat-icon>
  </button>

</ng-template>